
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Switch component
 */
var Switch = function Switch(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      name = _ref.name,
      onChange = _ref.onChange,
      id = _ref.id;
  return React.createElement(
    'label',
    { className: 'mdc-Switch' },
    React.createElement('input', {
      checked: checked,
      className: 'mdc-Switch-input',
      disabled: disabled,
      id: id,
      name: name,
      onChange: onChange,
      type: 'checkbox'
    }),
    React.createElement(
      'div',
      { className: 'mdc-Switch-track' },
      React.createElement('div', { className: 'mdc-Switch-thumb' })
    )
  );
};

/**
 * Property types
 */
Switch.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired

  /**
   * Default properties
   */
};Switch.defaultProps = {
  checked: false,
  disabled: false

  /**
   * Export switch component
   */
};export default Switch;


//////////////////
// WEBPACK FOOTER
// ../es/js/switch/index.js
// module id = 310
// module chunks = 0